import React, { useState, useEffect } from 'react';
import { gql, useQuery } from '@apollo/client';
import '../App.css';
import Tarjeta from './Tarjeta';

const GET_TARJETAS = gql`
query getTarjetas {
    getTarjetas {
        numeroTarjeta
        cvv
        contrasena
        nombreTitular
        contactoTitular
    }
}`;

function BuscarTarjeta() {
    const [filter, setFilter] = useState({
        nombreTitular: '',
        numeroTarjeta: '',
        cvv: '',
        contactoTitular: ''
    });
    const [selectedCard, setSelectedCard] = useState(null);
    const [inputPassword, setInputPassword] = useState('');
    const [showCard, setShowCard] = useState(false);

    const { loading, error, data } = useQuery(GET_TARJETAS);

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const nombreTitularParam = params.get('nombreTitular') || '';
        const numeroTarjetaParam = params.get('numeroTarjeta') || '';
        const cvvParam = params.get('cvv') || '';
        const contactoTitularParam = params.get('contactoTitular') || '';
        
        setFilter({
            nombreTitular: nombreTitularParam.toLowerCase(),
            numeroTarjeta: numeroTarjetaParam,
            cvv: cvvParam,
            contactoTitular: contactoTitularParam.toLowerCase()
        });
    }, []);

    if (loading) return <p>Esperando resultados...</p>;
    if (error) return <p>Error</p>;

    const handleCardClick = (card) => {
        setSelectedCard(card);
        setShowCard(false);
        setInputPassword('');
    };

    const handlePasswordSubmit = (e) => {
        e.preventDefault();
        if (selectedCard.contrasena === inputPassword) {
            setShowCard(true);
        } else {
            alert('Contraseña incorrecta');
        }
    };

    const filteredData = data.getTarjetas.filter(tarjeta =>
        tarjeta.nombreTitular.toLowerCase().includes(filter.nombreTitular) &&
        tarjeta.numeroTarjeta.includes(filter.numeroTarjeta) &&
        tarjeta.cvv.includes(filter.cvv) &&
        tarjeta.contactoTitular.toLowerCase().includes(filter.contactoTitular)
    );

    return (
        <div>
            {filteredData.map((tarjeta, index) => (
                <div key={index}>
                    <button className='btn btn-success' onClick={() => handleCardClick(tarjeta)}>verificar datos</button>
                </div>
            ))}
            
            {selectedCard && (
                <div>
                    {!showCard ? (
                        <form onSubmit={handlePasswordSubmit}>
                            <input
                                type="password"
                                placeholder="Ingrese contraseña"
                                value={inputPassword}
                                onChange={(e) => setInputPassword(e.target.value)}
                            />
                            <button className='btn btn-success' type="submit">buscar</button>
                        </form>
                    ) : (
                        <Tarjeta
                            nombreTitular={selectedCard.nombreTitular}
                            numeroTarjeta={selectedCard.numeroTarjeta}
                            cvv={selectedCard.cvv}
                            contactoTitular={selectedCard.contactoTitular}
                        />
                    )}
                </div>
            )}
        </div>
    );
}

export default BuscarTarjeta;
